import { useCallback, useState } from 'react';

export const useSpinner = callback => {
    const [ isSendingRequest, setIsSendingRequest ] = useState(false);
    const onApplyCallback = useCallback(async e => {
        setIsSendingRequest(true);
        await callback(e);
        setIsSendingRequest(false);
    }, [ callback ]);
    return [ isSendingRequest, onApplyCallback ];
};
